module.exports = __webpack_public_path__ + "img/1.cd078828.png";